// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"_1eIB4lpY56QC9iNKw9FO5i","description":"_3bL4cjV-lnPpETAveBSVbb","description-subtext":"wVYnS412ee70CdkxFXDmr"};